<template>
  <div class="@container">
    <RadioGroup v-model="model">
      <RadioGroupLabel>
        <p class="text-bold mb-1">Select Portal Pass Package</p>
      </RadioGroupLabel>
      <!-- 800px -->
      <div class="flex flex-col @[600px]:flex-row">
        <RadioGroupOption
          class="w-full flex"
          v-slot="{ checked, active }"
          :value="1"
        >
          <span
            class="flex gap-2 p-4 border border-neutral-400 dark:border-neutral-700 cursor-pointer rounded-md w-full"
            :class="
              checked
                ? 'border-cardinal-500  dark:bg-white dark:text-neutral-900 dark:border-white bg-neutral-800 text-white'
                : ''
            "
          >
            <div
              class="border border-neutral-600 rounded-full h-5 w-5 relative top-0.5 flex items-center justify-center shrink-0"
            >
              <i
                class="text-sm text-cardinal-500 dark:text-cardinal"
                :class="{
                  'fas fa-circle': checked,
                  '': !checked,
                }"
              ></i>
            </div>
            <div class="flex flex-col w-full ml-3">
              <strong clas="!font-bold">Single Season</strong>
              <p class="text-sm mt-2 @[600px]:mt-10 mb-5">
                <template
                  v-if="
                    sports?.includes('Baseball') && sports?.includes('Softball')
                  "
                >
                  Purchase the Multi-Sport Portal Pass for the 2025 season
                </template>
                <template v-else-if="sports?.includes('Baseball')">
                  Purchase the Baseball Portal Pass for the 2025 season
                </template>
                <template v-else-if="sports?.includes('Softball')">
                  Purchase the Softball Portal Pass for the 2025 season
                </template>
              </p>
              <p class="mt-auto font-bold text-2xl">${{ prices.single }}</p>
            </div>
          </span>
        </RadioGroupOption>
        <RadioGroupOption
          class="w-full flex"
          v-slot="{ checked, active }"
          :value="2"
        >
          <span
            class="flex gap-2 p-4 border border-neutral-400 dark:border-neutral-700 cursor-pointer rounded-md w-full"
            :class="
              checked
                ? 'border-cardinal-500  dark:bg-white dark:text-neutral-900 dark:border-white bg-neutral-800 text-white'
                : ''
            "
          >
            <div
              class="border border-neutral-600 rounded-full h-5 w-5 relative top-0.5 flex items-center justify-center shrink-0"
            >
              <i
                class="text-sm text-cardinal-500 dark:text-cardinal"
                :class="{
                  'fas fa-circle': checked,
                  '': !checked,
                }"
              ></i>
            </div>
            <div class="flex flex-col w-full ml-3">
              <strong clas="!font-bold">2 Seasons</strong>
              <UBadge
                class="mt-2 dark:border-[#4C2D2E] dark:border dark:bg-[#2B1F20] dark:text-cardinal-50 self-start"
              >
                Save ${{ savings.double }}
              </UBadge>
              <p class="text-sm mt-2 mb-5">
                <template
                  v-if="
                    sports?.includes('Baseball') && sports?.includes('Softball')
                  "
                >
                  Purchase the Multi-Sport Portal Pass for the 2025 and 2026
                  seasons
                </template>
                <template v-else-if="sports?.includes('Baseball')">
                  Purchase the Baseball Portal Pass for the 2025 and 2026
                  seasons
                </template>
                <template v-else-if="sports?.includes('Softball')">
                  Purchase the Softball Portal Pass for the 2025 and 2026
                  seasons
                </template>
              </p>
              <p class="mt-auto font-bold text-2xl flex flex-col gap-1">
                <span class="flex items-center gap-1">
                  <span
                    class="font-normal text-sm line-through relative top-0.5"
                    >${{ prices.fullDouble }}</span
                  >${{ prices.double }}
                </span>
              </p>
            </div>
          </span>
        </RadioGroupOption>
        <RadioGroupOption
          class="w-full flex"
          v-slot="{ checked, active }"
          :value="3"
        >
          <span
            class="flex gap-2 p-4 border border-neutral-400 dark:border-neutral-700 cursor-pointer rounded-md w-full"
            :class="
              checked
                ? 'border-cardinal-500  dark:bg-white dark:text-neutral-900 dark:border-white bg-neutral-800 text-white'
                : ''
            "
          >
            <div
              class="border border-neutral-600 rounded-full h-5 w-5 relative top-0.5 flex items-center justify-center shrink-0"
            >
              <i
                class="text-sm text-cardinal-500 dark:text-cardinal"
                :class="{
                  'fas fa-circle': checked,
                  '': !checked,
                }"
              ></i>
            </div>
            <div class="flex flex-col w-full ml-3">
              <strong clas="!font-bold">3 Seasons</strong>
              <UBadge
                class="mt-2 dark:border-[#4C2D2E] dark:border dark:bg-[#2B1F20] dark:text-cardinal-50 self-start"
              >
                Save ${{ savings.triple }}
              </UBadge>
              <p class="text-sm mt-2 mb-5">
                <template
                  v-if="
                    sports?.includes('Baseball') && sports?.includes('Softball')
                  "
                >
                  Purchase the Multi-Sport Portal Pass for the 2025, 2026, and
                  2027 seasons
                </template>
                <template v-else-if="sports?.includes('Baseball')">
                  Purchase the Baseball Portal Pass for the 2025, 2026, and 2027
                  seasons
                </template>
                <template v-else-if="sports?.includes('Softball')">
                  Purchase the Softball Portal Pass for the 2025, 2026, and 2027
                  seasons
                </template>
              </p>
              <p class="mt-auto font-bold text-2xl flex flex-col gap-1">
                <span class="flex items-center gap-1">
                  <span
                    class="font-normal text-sm line-through relative top-0.5"
                    >${{ prices.fullTriple }}</span
                  >${{ prices.triple }}
                </span>
              </p>
            </div>
          </span>
        </RadioGroupOption>
      </div>
    </RadioGroup>
  </div>
</template>

<script lang="ts" setup>
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue';
import { computed } from 'vue';

const props = defineProps<{}>();

const model = defineModel<number>();
const sports = defineModel<Sport[]>('sports');
const existingSports = defineModel<Sport[] | undefined>('existingSports');

const { prices, savings } = usePortalPassPricing(sports, existingSports);
</script>
